import styled from 'styled-components'
const Wrapper = styled.div`
.resource-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor : pointer;
}

.resource-container span{
color: #1D1D1D;

font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: normal;
}
 `
  export default Wrapper